import { Select as AntSelect, SelectProps as AntSelectProps } from "antd";
import styles from "./Select.module.scss";
import classNames from "classnames";
import React, { useRef } from "react";

type SelectProps = {
  label?: React.ReactNode;
  name?: string;
  wrapClassName?: string;
  outlined?: boolean;
} & AntSelectProps;

const clean = ["id", "label", "name"].reduce((target, value) => {
  target[value] = undefined;
  return target;
}, {} as any);

function Select({
  wrapClassName,
  outlined,
  ...props
}: SelectProps) {
  const ref: React.MutableRefObject<HTMLInputElement | null> = useRef(null);
  const init = useRef((props.value || props.defaultValue) ?? "");

  return <label className={classNames(styles.select, wrapClassName, { [styles.outlined]: outlined })}>
    {props.label}
    <AntSelect
      {...props}
      {...clean}
      filterOption={(input, option) => {
        if (typeof props.filterOption === 'function') {
          return props.filterOption(input, option);
        }
        if (typeof option?.label === "string") {
          return option.label.toLowerCase().includes(input.toLowerCase());
        }
        if (typeof option?.text === "string") {
          return option.text.toLowerCase().includes(input.toLowerCase());
        }
      }}
      labelRender={props.labelRender || props.optionRender}
      showSearch={props.showSearch ?? true}
      onChange={(value, option) => {
        if (ref.current) {
          ref.current.value = value ?? "";
          ref.current.defaultValue = "";
          init.current = "";
        }
        props.onChange?.(value, option);
      }}
    />
    <input type="text" defaultValue={init.current} tabIndex={-1} readOnly hidden id={props.id} name={props.name} ref={ref} />
  </label>
}

export { Select };
